import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
  //mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/meal_skipping',
      name: 'meal_skipping',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('./views/MealSkipping.vue')
    },
    {
      path: '/travel',
      name: 'travel',
      component: () => import('./views/Travel.vue')
    },
    {
      path: '/travel_list',
      name: 'travel_list',
      component: () => import('./views/TravelList.vue')
    },
    {
      path: '/serial',
      name: 'serial',
      component: () => import('./views/SequencialMealSkipping.vue')
    },
  ]
})
